import { createContextWithoutDefault, useContextWithoutDefault } from "~utils";

// The seam specs use to drive `FirebaseAuthMockProvider` straight into a session. The
// port's own sign-in methods derive the uid themselves — a fixed mock User for Google,
// one per email for email; these pick the uid and profile exactly, rather than taking
// the signed-in user as a render-time prop.
export function useMockFirebaseAuth(): useMockFirebaseAuthReturn {
  return useContextWithoutDefault(MockFirebaseAuthContext);
}

export type useMockFirebaseAuthReturn = {
  signInAnonymously: (userId: string) => void;
  logIn: (user: MockFirebaseAuthUser) => void;
};

export type MockFirebaseAuthUser = {
  userId: string;
  name?: string;
  email?: string;
  photoUrl?: string;
};

export const MockFirebaseAuthContext =
  createContextWithoutDefault<useMockFirebaseAuthReturn>();
